import { render, staticRenderFns } from "./authorizedinvitation.vue?vue&type=template&id=3597795b&scoped=true"
import script from "./authorizedinvitation.vue?vue&type=script&lang=js"
export * from "./authorizedinvitation.vue?vue&type=script&lang=js"
import style0 from "./authorizedinvitation.vue?vue&type=style&index=0&id=3597795b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3597795b",
  null
  
)

export default component.exports